import React, { useEffect, useState } from 'react';
import './SuitsStyle.css';
import { useNavigate } from 'react-router-dom';
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { IoMdMail } from "react-icons/io";
import { emSuits } from '../model/emSuits';

interface Props {
  loggedState: number;
  loggedID: String;
  setSuitID: React.Dispatch<React.SetStateAction<number>>;
  setSuitName: React.Dispatch<React.SetStateAction<string>>;
}

const Suits = ({ loggedState, loggedID, setSuitID, setSuitName }: Props) => {
  const [suits, setSuits] = useState<emSuits[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const navigate = useNavigate();

  const back = () => {
    navigate("/MainPage");
  };

  useEffect(() => {
    ReadSuits(-2, loggedID);
  }, []);

  const editSuit = (id: number, name: string) => {
    setSuitID(id);
    setSuitName(name)
    navigate("/EditSuit", { state: { id: id } });
  };

  const filteredCars = suits.filter(suit =>
    suit.name.toLowerCase().includes(searchTerm.toLowerCase()) // Filter nach Name
  );

  const ReadSuits = async (emID: number, loggedID: String) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadSuits.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        //console.log('Einsatzkleidung vorhanden:', data);
        setSuits(data);
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen der Einsatzkleidung:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
  };


  const updateName = (id: number, field: string, value: string) => {
    setSuits((prevCars) =>
      prevCars.map((car) =>
        car.ID === id
          ? { ...car, [field]: value } // Update das Feld (activeMember oder agt)
          : car
      )
    );
  };

  const handleNameChange = async (suitID: String, value: String) => {
    const column = 'name'
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateSuit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze 
          suitID,
          column,
          value,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if (data.status === 'success') {
          ReadSuits(-2, loggedID);
        }
        else {
          alert("Garnitur konnte nicht aktualisiert werden");
        }

      } else {
        const data = await response.json();
        alert("Garnitur konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
  };

  const deleteSuits = async (ID: number) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteSuit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if (data.status === 'success') {
          alert("Garnitur wurde gelöscht");
          ReadSuits(-2, loggedID)
        }
        else {
          alert("Garnitur konnte gelöscht werden werden");
        }

      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Garnitur konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }

  };

  const suitAdd = async (loggedID: String) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddSuit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if (data.status === 'success') {
          alert("Garnitur wurde angelegt");
          ReadSuits(-2, loggedID)
        }
        else {
          alert("Garnitur konnte nicht angelegt werden");
        }

      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Garnitur konnte nicht angelegt werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }

  };

  const AddSuit = () => {
    suitAdd(loggedID)

  };

  const DeleteSuits = (id: number) => {
    deleteSuits(id)
  };

  return (
    <div className="App" style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
      <div className="search-box-container">
        <div className="header">
          <h2>Einsatzkleidung-Verwaltung</h2>
          <button className="new-button" onClick={() => AddSuit()}>Neue Garnitur</button>
        </div>
        <div className="search-box">
          <label htmlFor="search">Suche:</label>
          <input
            type="text"
            id="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} // Überwachen der Eingabe
          />
        </div>
      </div>


      <table className="table">
        <thead className="table-header">
          <tr>
            <th className="col-1">Name</th>
            <th className="col-2">Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {filteredCars.map((row) => (
            <tr key={row.ID}>
              <td className="col-1">
                <input
                  type="text"
                  value={row.name}
                  onChange={(e) => updateName(row.ID, 'name', e.target.value)}
                  onBlur={(e) => handleNameChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                />
              </td>
              <td className="col-2">
                <span className='SuitStyle_icon' onClick={() => editSuit(row.ID,row.name)}>
                  <AiFillEdit></AiFillEdit>
                </span>
                <span className='SuitStyle_icon' onClick={() => DeleteSuits(row.ID)}>
                  <AiFillDelete></AiFillDelete>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>


    </div>
  );
}

export default Suits;
